/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'prop-types',
	'@ba/ba-ui-carbon-toolkit',
	'@ba/ba-graphics/dist/icons-js/overflow-menu--vertical_32'
], function(React, PropTypes, Carbon_toolkit, contextMenuIcon) {
	const { Component } = React;
	const { Container, SVGIcon, FlexLayout, FlexItem, TruncatedText } = Carbon_toolkit;

	class TemplateLayout extends Component {

		constructor(props) {
			super(props);
		}

		render() {
			return (
				<Container onDoubleClick={() => this.props.action()}>
					{this._getContent(this.props.layoutSpec)}
				</Container>
			);
		}

		_getContent (layoutSpec) {
			if (layoutSpec.layout.navigationTemplates && layoutSpec.layout.navigationTemplates.includes('custom')) {
				return this._getTemplateThumbnail(layoutSpec);
			}
			return this._getPreview(layoutSpec.layout);
		}

		_getPreview (layout) {
			const style = {};
			if (layout.style) {
				for (let name in layout.style) {
					if (layout.style.hasOwnProperty(name)) {
						style[name] = layout.style[name];
					}
				}
			}

			let css = layout.css || '';
			css += ' ' + layout.type;

			let items = [];
			if (layout.items) {
				items = layout.items.map(item => this._getPreview(item));
			}
			return (<div className={css} style={style}>{items}</div>);
		}

		_getTemplateThumbnail (layoutSpec) {
			const { layout, thumbnail, contextMenuEnabled, template } = layoutSpec;
			const { name, label, location } = layout;
			if (!name || !thumbnail) {
				return;
			}
			return (
				<FlexLayout
					fullHeight
					direction="column"
					className='layoutThumbnailContainer'
				>
					<FlexItem alignSelf='center' className='layoutThumbnail'>
						<img
							src={`data:image/png;base64,${thumbnail}`}
						/>
					</FlexItem>
					<FlexItem>
						<FlexLayout
							direction="row"
							justifyContent='space-between'
							alignItems='center'
						>
							<TruncatedText
								className='layoutThumbnailLabel'
								value={label}
							/>
							{ contextMenuEnabled ?
								(<FlexItem alignSelf='right' className='layoutContextMenuButton'
									onClick={event => this._onContextMenuButtonClick(template, event)}
								>
									<SVGIcon
										iconId={contextMenuIcon.default.id}
									/>
								</FlexItem>): null
							}
						</FlexLayout>
					</FlexItem>
					<FlexItem>
						<TruncatedText
							className='layoutLocation'
							value={location}
						/>
					</FlexItem>
				</FlexLayout>
			);
		}

		_onContextMenuButtonClick (template, event) {
			if (template) {
				this.props.showContextMenu(template, event.pageX, event.pageY);
			}
		}
	}

	TemplateLayout.propTypes = {
		action: PropTypes.func.isRequired,
		layoutSpec: PropTypes.object.isRequired,
		showContextMenu: PropTypes.func
	};

	return TemplateLayout;
});
